module.exports = __webpack_public_path__ + "img/insurita-value-one-shape.403ed7e2.svg";